import { init } from "@rematch/core";
import patientsStore from "../patients/store/patients-store";
import appointmentsStore from "../appointments/store/appointments-store";
import commonStore from "../common/store/common-store";
import rolesStore from "../roles/store/roles-store";

const store = init({
  models: {
    patients: patientsStore,
    appointments: appointmentsStore,
    roles: rolesStore,
    common: commonStore,
  },
});
export default store;
